/** 耗点生成相关提示文案（全站统一） */

export const PAID_GEN_LEAVE_TITLE = '确定要离开？';

export function paidGenLeaveMessage(label: string, generating: boolean): string {
  if (generating) {
    return `「${label}」正在进行中，点数已扣除不会退回。\n\n现在离开可能错过结果，也无法自动保存。\n\n确定要离开此页吗？`;
  }
  return `你还有「${label}」的结果尚未确认。\n\n离开不会自动存入素材库，已扣点数不会退回。\n\n确定要离开此页吗？`;
}

export const PAID_GEN_ABANDON_TITLE = '确定放弃这次生成？';

export const PAID_GEN_ABANDON_MESSAGE =
  '点数已扣除不会退回，这张素材也不会存入你的档案库。\n\n确定要放弃这次生成结果吗？';

export const PAID_GEN_ABANDON_WARDROBE_MESSAGE =
  '本次换装预览已消耗免费次数或点数。放弃后不会存入角色相册。\n\n确定要放弃吗？';

export const PAID_GEN_START_CONFIRM = (label: string, cost: number, extra = '') =>
  `「${label}」将扣除 ${cost} 点（不可退回）${extra}。\n\n确定要生成吗？`;
